import { typeCheck } from "@knyt/artisan";
import { isElementDeclaration } from "./other.js";
import { resolveDeclarationTree } from "./resolveDeclarationTree.js";
/**
 * Extracts the text from an element declaration.
 */
export async function extractDeclarationText(input) {
    if (input === undefined) {
        return [];
    }
    const tree = await resolveDeclarationTree(input);
    const textPieces = [];
    for (const child of tree.children) {
        if (isElementDeclaration(child)) {
            textPieces.push(...(await extractDeclarationText(child)));
            continue;
        }
        if (typeof child === "string") {
            textPieces.push(child);
            continue;
        }
        if (typeof child === "number") {
            textPieces.push(String(child));
            continue;
        }
        // Falsy values are ignored, and DOM constructs are not included in the text.
        typeCheck(typeCheck.identify());
    }
    return textPieces;
}
